import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Div } from '../../Atoms/Div';
import { Flex } from '../../Atoms/Flex';
import { Text } from '../../Atoms/Text';
import PropTypes from 'prop-types';

const DEFAULT_WIDTH = '400px';

export function CenteredContainer({
  children,
  title,
  subTitle,
  width,
  boxShadow,
  background,
  innerBackground,
  border,
  titleColor,
  subTitleColor,
  useSpacers,
  m,
  p,
  pagePadding,
  overflow,
}) {
  const theme = useTheme();

  const titleContainerStyles = {
    whiteSpace: 'pre-wrap',
    marginRight: '10vw',
    marginLeft: '10vw',
    textAlign: 'center',
    width: '100%',
    justifyContent: 'center',
  };

  return (
    <Div
      dataTest="centeredcontainer-template"
      width="100vw"
      height="calc(100vh - 60px)"
      background={background}
      overflow={overflow}
    >
      {/*These spacers help keep the container biased towards the top of center in various screen sizes*/}
      {useSpacers && <Div width="200px" height="200px" />}
      <Flex
        width="100%"
        height="fit-content"
        direction="column"
        alignItems="center"
        justifyContent="center"
        p={pagePadding}
      >
        {title && (
          <Flex {...titleContainerStyles}>
            <Text
              variant="h1"
              color={titleColor || theme.palette.text.primary}
              m="20px 0px 10px 0px"
            >
              {title}
            </Text>
          </Flex>
        )}
        {subTitle && (
          <Flex {...titleContainerStyles}>
            <Text
              variant="body1"
              mb="20px"
              color={subTitleColor || theme.palette.text.secondary}
            >
              {subTitle}
            </Text>
          </Flex>
        )}
        <Div
          background={innerBackground || theme.palette.background.paper}
          borderRadius="6px"
          border={border || `1px solid ${theme.palette.divider}`}
          padding={5}
          boxShadow={boxShadow}
          width={width || DEFAULT_WIDTH}
          m={m}
          p={p}
        >
          {children}
        </Div>
        {!useSpacers && <Div width="100px" height="100px" />}
      </Flex>
      {useSpacers && <Div width="900px" height="900px" />}
    </Div>
  );
}

CenteredContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  width: PropTypes.string,
  border: PropTypes.string,
  boxShadow: PropTypes.string,
  background: PropTypes.string,
  innerBackground: PropTypes.string,
  titleColor: PropTypes.string,
  subTitleColor: PropTypes.string,
  useSpacers: PropTypes.bool,
  m: PropTypes.string,
  p: PropTypes.string,
  pagePadding: PropTypes.string,
  overflow: PropTypes.string,
};
export default CenteredContainer;
